import Dropdown from 'react-bootstrap/Dropdown';

import { useState } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { GeneralTitle, LableTitle } from "../../../styles/title.style";
import {
  RowBox,
  LeftBox,
  RightBox,
  ColumnBox,
  TopBox,
  BottomBox
} from "../../../styles/box.style";

import LanuchNew from "./LanuchNew";
import AlreadyLanuched from "./AlreadyLanuched";

const Lanuch = () => {
  const [deviceModel, setDeviceModel] = useState();
  const selectDeviceModel = (eventKey) => {
    setDeviceModel(eventKey);
  }

  const [firmwareVersion, setFirmwareVersion] = useState();
  const selectFirmwareVersion = (eventKey) => {
    setFirmwareVersion(eventKey);
  }

  return (
    <>
      <GeneralTitle>Launch Firmware</GeneralTitle>
      <RowBox>
        <LeftBox>
          <LableTitle>Device Model</LableTitle>
        </LeftBox>
        <RightBox>
          <Dropdown onSelect={selectDeviceModel}>
            <Dropdown.Toggle>
              {deviceModel}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="none">None</Dropdown.Item>
              <Dropdown.Item eventKey="DBA-1520">DBA-1520</Dropdown.Item>
              <Dropdown.Item eventKey="DBA-1210">DBA-1210</Dropdown.Item>
              <Dropdown.Item eventKey="DBS-2000">DBS-2000</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </RightBox>
      </RowBox>
      <RowBox>
        <LeftBox><LableTitle>Firmware Version</LableTitle></LeftBox>
        <RightBox>
          <Dropdown onSelect={selectFirmwareVersion}>
            <Dropdown.Toggle>
              {firmwareVersion}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="none">None</Dropdown.Item>
              <Dropdown.Item eventKey="2.02.004">2.02.004</Dropdown.Item>
              <Dropdown.Item eventKey="2.02.006">2.02.006</Dropdown.Item>
              <Dropdown.Item eventKey="2.02.008">2.02.008</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </RightBox>
      </RowBox>
      <ColumnBox>
        <TopBox><LableTitle>Select Organizations</LableTitle></TopBox>
        <BottomBox>
          <Tabs defaultActiveKey="lauch" className="mb-3">
            <Tab eventKey="lauch-new" title="Lanuch New" className="second">
              <LanuchNew />
            </Tab>
            <Tab eventKey="already-lanuched" title="Alreday Lanuched" className="second">
              <AlreadyLanuched />
            </Tab>
          </Tabs>
        </BottomBox>
      </ColumnBox>
    </>
  );
};

export default Lanuch;